import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import numeral from 'numeral'
import {
  Div, H4, Button, P, Label,
} from 'konsys-ui'
import {
  RadioInput, RadioLabel, RadioWrapper, RadioLabelWrapper, RadioTextLabel,
  IconRotate, Text,
} from './styled'
import { theme, screenSize } from '../../styles/_variables'

const Radio = ({
  radioId, radioName, text, label, margin, onChange, value, checked, price, isMinimum, img, padding,
}) => (
  <Div display='flex' position='relative' margin={margin} padding={padding}>
    <RadioWrapper imgRadio={!_.isEmpty(img)}>
      <RadioInput
        value={value}
        type='radio'
        id={radioId}
        name={radioName}
        onChange={e => onChange(e.target.value)}
        checked={checked}
      />
      <RadioLabel img={img} htmlFor={radioId} />
    </RadioWrapper>
    <Div display='flex' justifyContent='space-between' width='100%'>
      <RadioLabelWrapper htmlFor={radioId}>
        <Div margin='0 16px' display='flex' flexDirection='column'>
          <P>{text}</P>
          <RadioTextLabel font={img !== '' && 'Kanit'} margin={img !== '' ? '4px 0 0' : '2px 0 0'}>{label}</RadioTextLabel>
        </Div>
      </RadioLabelWrapper>
      { price >= 0 && <span>{ isMinimum && <Label regular={true}>Starting at</Label>} <Text style={{ width: 'max-content' }}>{numeral(price).format('0,0')} THB</Text></span>}
    </Div>
  </Div>
)

const ImageRadio = ({
  radioId, radioName, text, label, margin, onChange, value, checked,
}) => (
  <Div display='flex' margin={margin}>
    <RadioWrapper>
      <RadioInput
        value={value}
        type='radio'
        id={radioId}
        name={radioName}
        onChange={e => onChange(e.target.value)}
        checked={checked}
      />
      <RadioLabel img="http://unsplash.it/200/200" imgRadio={true} htmlFor={radioId} />
    </RadioWrapper>
    <RadioLabelWrapper htmlFor={radioId}>
      <Div margin='0 0 0 16px' display='flex' flexDirection='column'>
        <P>{text}</P>
        <Label font='kanit' margin='8px 0 0'>{label}</Label>
      </Div>
    </RadioLabelWrapper>
  </Div>
)

const RadioGroup = ({
  radioName, value, onChange, isCheckbox, RadioGroupMargin,
}) => (
  <Div margin={RadioGroupMargin}>
  {
    value.length > 0 && value.map((v, index) => (
      <Radio
        radioName={radioName}
        key={index}
        text={v.text}
        label={v.label}
        value={v.value}
        radioId={v.radioId}
        checked={v.checked}
        margin={v.img ? '0' : index !== value.length ? '0 0 24px' : '0'}
        padding={v.img ? index !== value.length ? '16px 0' : '0' : '0' }
        onChange={val => onChange(val)}
        price={v.price}
        isMinimum={v.isMinimum}
        isCheckbox={isCheckbox}
        img={v.img ? v.img : ''}
      />
    ))
  }
  </Div>
)

const Template = ({
  title, buttonProps, children, reverse, reset, resetFunction, subtitle, confirm,
}) => {
  const [windowSize, setWindowSize] = useState(window.innerWidth)
  useEffect(() => {
    window.addEventListener('resize', () => setWindowSize(window.innerWidth))
  })
  return (
    <Div>
      { <Div display='flex' justifyContent='space-between' margin='0 0 48px' >
          <Div>
            <H4 letterSpacing='1px' display="block" playfair={true}>{title}</H4>
            { subtitle && <P color={theme.color.purplishGrey} letterSpacing='1px' playfair={true} margin='0 0 0'>{subtitle}</P>}
            </Div>
            {
              reset && <Button text='Clear all' onClick={() => resetFunction()}/>
            }
        </Div>
      }
      {
        confirm && windowSize <= screenSize.tablet
        && <Div margin='0 0 24px' display='flex'>
          {
            buttonProps && _.find(Object.keys(buttonProps), v => v === 'back')
            && <Button fullWidth={true} margin='0 4px 0 0' {...buttonProps.back} />
          }
          {
            buttonProps && _.find(Object.keys(buttonProps), v => v === 'next')
            && <Button inverse={true} fullWidth={true} margin='0 0 0 4px' {...buttonProps.next} />
          }
        </Div>
      }
      {
        children
      }
      {
        windowSize <= screenSize.tablet && confirm
          ? null
          : !reverse
            ? <Div margin='48px 0 0'>
                {
                  buttonProps && _.find(Object.keys(buttonProps), v => v === 'next')
                  && <Button inverse={true} fullWidth={true} margin='8px 0 0' {...buttonProps.next} />
                }
                {
                  buttonProps && _.find(Object.keys(buttonProps), v => v === 'back')
                  && <Button fullWidth={true} margin='8px 0 0' {...buttonProps.back} />
                }
              </Div>
            : <Div margin='48px 0 0'>
                {
                  buttonProps && _.find(Object.keys(buttonProps), v => v === 'back')
                  && <Button fullWidth={true} margin='8px 0 0' {...buttonProps.back} />
                }
                {
                  buttonProps && _.find(Object.keys(buttonProps), v => v === 'next')
                  && <Button inverse={true} fullWidth={true} margin='8px 0 0' {...buttonProps.next} />
                }
              </Div>
      }
    </Div>
  )
}

const TextWithIcon = ({ icon, text }) => (
  <Div textAlign='center'>
    {
      icon && <IconRotate className={icon} />
    }
    <P textAlign='center' display='block' color={theme.color.silver}>{text}</P>
  </Div>
)

export {
  RadioGroup, Template, Radio, ImageRadio, TextWithIcon,
}



// WEBPACK FOOTER //
// ./src/pages/reserve/utils.jsx